import { PATHS } from "@/lib/content";
import { Reveal } from "@/components/common/Reveal";
import { Icon } from "@/components/common/Icon";
import { usePathSelector } from "@/context/PathSelectorContext";
import { ArrowRight } from "lucide-react";

// Major interactive section — clean white choices that open the guided journey.
// DEFAULT: white + slate border. HOVER: soft-blue background + royal-blue border.
export const TellUsSection = () => {
  const { openSelector } = usePathSelector();
  return (
    <section className="border-t border-border bg-white py-24 lg:py-32" data-testid="tell-us-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <h2 className="font-heading text-3xl font-extrabold tracking-tight text-slate-900 md:text-4xl lg:text-5xl">
            Tell us what you need.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            We start with your problem, not a service menu. Tell us who you are, and we'll guide
            you from there.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4">
          {PATHS.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <button
                onClick={() => openSelector(p.id)}
                data-testid={`tell-us-path-${p.id}`}
                className="group flex w-full items-center gap-5 rounded-xl border border-border bg-white px-6 py-6 text-left transition-[background-color,border-color] duration-200 hover:border-blue-600 hover:bg-blue-50"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600 transition-colors duration-200 group-hover:bg-blue-600 group-hover:text-white">
                  <Icon name={p.icon} className="h-5 w-5" />
                </span>
                <span className="min-w-0">
                  <span className="block font-heading text-lg font-bold text-slate-900 md:text-xl">{p.label}</span>
                  <span className="mt-1 block text-slate-500">{p.blurb}</span>
                </span>
                <ArrowRight className="ml-auto h-5 w-5 shrink-0 -translate-x-2 text-slate-300 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:text-blue-600 group-hover:opacity-100" />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
